/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import type { PositionAlignment, HorizontalAlignment, VerticalAlignment } from 'devextreme/common';
import type { CollisionResolutionCombination, CollisionResolution } from 'devextreme/common/core/animation';

import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-menu-position',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoMenuPositionComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get at(): PositionAlignment | { x?: HorizontalAlignment, y?: VerticalAlignment } {
        return this._getOption('at');
    }
    set at(value: PositionAlignment | { x?: HorizontalAlignment, y?: VerticalAlignment }) {
        this._setOption('at', value);
    }

    @Input()
    get boundary(): any | string {
        return this._getOption('boundary');
    }
    set boundary(value: any | string) {
        this._setOption('boundary', value);
    }

    @Input()
    get boundaryOffset(): string | { x?: number, y?: number } {
        return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value: string | { x?: number, y?: number }) {
        this._setOption('boundaryOffset', value);
    }

    @Input()
    get collision(): CollisionResolutionCombination | { x?: CollisionResolution, y?: CollisionResolution } {
        return this._getOption('collision');
    }
    set collision(value: CollisionResolutionCombination | { x?: CollisionResolution, y?: CollisionResolution }) {
        this._setOption('collision', value);
    }

    @Input()
    get my(): PositionAlignment | { x?: HorizontalAlignment, y?: VerticalAlignment } {
        return this._getOption('my');
    }
    set my(value: PositionAlignment | { x?: HorizontalAlignment, y?: VerticalAlignment }) {
        this._setOption('my', value);
    }

    @Input()
    get of(): any | string {
        return this._getOption('of');
    }
    set of(value: any | string) {
        this._setOption('of', value);
    }

    @Input()
    get offset(): string | { x?: number, y?: number } {
        return this._getOption('offset');
    }
    set offset(value: string | { x?: number, y?: number }) {
        this._setOption('offset', value);
    }


    protected get _optionPath() {
        return 'position';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoMenuPositionComponent
  ],
  exports: [
    DxoMenuPositionComponent
  ],
})
export class DxoMenuPositionModule { }
